/**
 * Created by gocey on 28.08.17.
 */

Box.Application.addModule('sv-carousel', function(context) {

    var _self = context;

    // retrieve a reference to jQuery
    var $ = context.getGlobal('jQuery');

    var _initCarousel = function () {
        _self.$element = $(context.getElement());
        var carousel = null;
        var carousel_Config = {
            auto: true,
            stopAutoOnClick: false,
            pager: false,
            autoStart: false
        };

        var isMobile = window.matchMedia("only screen and (max-width: 768px)");
        if (isMobile.matches) {
            if(carousel == null)
                carousel = _self.$element.bxSlider(carousel_Config);
        }

        $(window).resize(function() {
            var isMobile = window.matchMedia("only screen and (max-width: 768px)");
            if (isMobile.matches) {
                if(carousel == null)
                    carousel = _self.$element.bxSlider(carousel_Config);
                else
                    carousel.reloadSlider(); //reloading the slider if already instance present
            } else {
                if(carousel){
                    carousel.destroySlider();
                    carousel = null;
                }
            }
        });
    };

    return {

        init: function() {
            _initCarousel()
        }

    };
});



// WEBPACK FOOTER //
// ./sv_cms/static/assets/js/modules/sv-carousel.js